import React from 'react'
import Chat from './Chat'

export default function JivoChat(props) {
  const {integrations: config} = props
  const jivoChatId = config && config.integrations && config.integrations.jivoChatId
  if (!jivoChatId) return null
  return <Chat jivoChatId={jivoChatId} />
}
